import { GetStaticPropsContext, InferGetServerSidePropsType } from 'next';
import React from 'react';
import { CustomHead, Layout } from '@/components/Commons';
import { AIKA_LOGO_SQUARE } from '@/shared/constants';
import { NextPageWithLayout } from '@/pages/_app';
import { getServerSideProps } from 'next/dist/build/templates/pages';
import { productSans } from '@/constants/fonts';
import Image from 'next/image';
import Link from 'next/link';

const BlogsPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return (
    <main className={`text-white ${productSans.className} mb-32`}>
      <div className="relative mx-auto min-h-screen w-full max-w-[1440px]">
        <div className="flex h-1/3 w-full flex-col items-start gap-10 pt-50 max-md:pt-32">
          <div className="text-8xl max-md:px-6 max-md:text-4xl">Latest Updates</div>
          <div className="text-3xl max-md:px-6 max-md:text-xl">All the latest Aika news, straight from the team.</div>
        </div>
        <div className="mt-40 grid grid-cols-2 gap-6 max-md:mt-12 max-md:grid-cols-1 max-md:px-6">
          <Link className="group rounded-2xl border border-white/10 bg-white/5 p-2 pb-8 text-white" href="/blogs/expo">
            <div className="relative aspect-video w-full overflow-hidden rounded-t-2xl">
              <Image
                fill
                alt="expo"
                style={{ objectFit: 'cover' }}
                className="transition duration-500 ease-in-out group-hover:scale-125"
                src="/images/blogs/expo/78008fae31a0da75223fc74e3c2fb48f.jpg"
              />
            </div>
            <div className="my-6 px-5 text-3xl font-black max-md:mb-4 max-md:text-xl">
              AIKA at the World Expo 2025 Osaka: Where Innovation Meets Humanity
            </div>
            <div className="mb-6 flex gap-3 px-5 max-md:mb-2">
              <span className="rounded-4xl bg-gray-700 px-4 py-1 font-extralight italic max-md:text-sm">
                20 Jan 2026
              </span>
              <span className="rounded-4xl bg-gray-700 px-4 py-1 font-extralight italic max-md:text-sm">Expo</span>
            </div>
            <div className="px-5 text-base font-normal text-gray-300 max-md:text-sm">
              This year, AIKA had the privilege of participating in one of the most significant global events of 2025 —
              the World Expo in Osaka, Japan. Held on the artificial island of Yumeshima under the theme "Designing
              Future Society for Our Lives," EXPO 2025 brought together over 160 countries and welcomed more than 29
              million visitors from around the world...
            </div>
          </Link>
          <Link
            className="group rounded-2xl border border-white/10 bg-white/5 p-2 pb-8 text-white"
            href="/blogs/tech-crunch"
          >
            <div className="relative aspect-video w-full overflow-hidden rounded-t-2xl">
              <Image
                fill
                alt="Tech Crunch"
                style={{ objectFit: 'cover' }}
                className="transition duration-500 ease-in-out group-hover:scale-125"
                src="/images/blogs/tech-crunch/05436b813efd3faf12149d3217674c5f.jpg"
              />
            </div>
            <div className="my-6 px-5 text-3xl font-black max-md:mb-4 max-md:text-xl">
              AIKA Takes the Stage at TechCrunch Disrupt 2025
            </div>
            <div className="mb-6 flex gap-3 px-5 max-md:mb-2">
              <span className="rounded-4xl bg-gray-700 px-4 py-1 font-extralight italic max-md:text-sm">
                20 Jan 2026
              </span>
              <span className="rounded-4xl bg-gray-700 px-4 py-1 font-extralight italic max-md:text-sm">
                Tech Crunch
              </span>
            </div>
            <div className="px-5 text-base font-normal text-gray-300 max-md:text-sm">
              This October, the AIKA team traveled to San Francisco to participate in TechCrunch Disrupt 2025 — one of
              the world's most prestigious technology conferences, bringing together leading startups, investors, and
              visionaries shaping the future of technology...
            </div>
          </Link>
        </div>
      </div>
    </main>
  );
};

BlogsPage.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title={'Brave New World - Aika'}
        description={
          'Create stories, take on challenges, make friends – all of this in AIKA, a place where technology turns your time into unforgettable moments'
        }
        image={AIKA_LOGO_SQUARE}
      />
      <Layout hideHeader={false} stickyHeader={false}>
        {page}
      </Layout>
    </>
  );
};
export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

export default BlogsPage;
